import { useRouter } from 'next/router';

const GoBackButton = (props) => {
  const { backRoute } = props;
  const router = useRouter();

  const handleClick = () => {
    if (backRoute) {
      router.push(backRoute);
    } else {
      router.back();
    }
  };

  return (
    <a className="GoBackButton" onClick={handleClick}>
      <svg className="GoBackButton-icon">
        <use xlinkHref="#arrow-left" />
      </svg>
    </a>
  );
};

export default GoBackButton;
